import { render, staticRenderFns } from "./houseSet.vue?vue&type=template&id=b4d19636&scoped=true&"
import script from "./houseSet.vue?vue&type=script&lang=js&"
export * from "./houseSet.vue?vue&type=script&lang=js&"
import style0 from "./houseSet.vue?vue&type=style&index=0&id=b4d19636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d19636",
  null
  
)

export default component.exports